// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { GitHub } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconGitHub(props: any) {
    return <IconBase icon={GitHub} {...props} />
  }

  export default IconGitHub
  